import { CSS, Tag } from '@grupoboticario/flora-react'
import { MouseEventHandler } from 'react'

export type MagazineShortcutVariants = 'mobile' | 'desktop'

export type MagazineShortcutProps = {
  label: string
  checked?: boolean
  onClick?: MouseEventHandler<HTMLSpanElement>
  variant?: MagazineShortcutVariants
}

const styles = (variant: MagazineShortcutVariants): CSS => ({
  cursor: 'pointer',
  textTransform: variant === 'mobile' ? 'uppercase' : 'unset',
})

export const MagazineShortcut = ({
  checked,
  label,
  variant = 'mobile',
  onClick,
}: MagazineShortcutProps) => {
  return (
    <Tag
      autotagging-flora="on"
      css={styles(variant)}
      role="checkbox"
      data-flora="tag"
      data-flora-text={label}
      data-autotagging-flora-section="shortcuts"
      aria-label={`Ir para ${label}`}
      aria-checked={checked}
      variant="success"
      size={variant === 'mobile' ? 'medium' : 'small'}
      shape={checked ? undefined : 'ghost'}
      onClick={onClick}
    >
      {label}
    </Tag>
  )
}
